/** localStorage key holding the visitor's ConsentState (also read by the inline script in the root layout). */
export const STORAGE_KEY = "uxui-cookie-consent";

/** Window event fired with the new ConsentState whenever consent is applied. */
export const CONSENT_EVENT = "cookie-consent-change";
